import { DatePicker, TimePicker, LocaleProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_US";
import React, { Component } from "react";
import styled from "styled-components";
import { AnalyticStore } from "Store";
import { InlineWidgetWrapper, WidgetMember } from "./components/Widget";
import PickerAgent from "module-common/PickerAgentWithQuery";
import PickerChannel from "module-common/PickerChannelWithQuery";
import Field from "./components/Field";
import { observer } from "mobx-react";
import styledComponents from "styled-components";
import moment from "moment";

const Wrapper = InlineWidgetWrapper.extend`
  margin: 10px 10px;
  border: solid 2px #ebeef7;
  border-radius: 5px;
`;

function prepareDisplayName(arr) {
  const length = arr.length;
  let text = "";
  for (let i = 0; i < length; i++) {
    const name = arr[i].displayName;
    if (i === 0) {
      text += name;
    } else if (i === length - 1) {
      text += ` and ${name}`;
    } else {
      text += `, ${name}`;
    }
  }
  text += " selected";
  return text;
}

export default observer(
  class Filter extends Component {
    onChangeDate = e => {
      AnalyticStore.startTime = e[0];
      AnalyticStore.endTime = e[1];
    };

    onChannelHandlerChange(e) {
      if (e.value) {
        // should disallow duplicate
        const exist = AnalyticStore.companyChannelHandlerList.find(
          elem => elem.id === e.value.id
        );
        if (!exist) {
          AnalyticStore.companyChannelHandlerList.push(e.value);
        }
      } else {
        AnalyticStore.companyChannelHandlerList.clear();
      }
    }

    onAgentChange(e) {
      if (e.value) {
        const exist = AnalyticStore.agentList.find(
          elem => elem.id === e.value.id
        );
        if (!exist) {
          // should disallow duplicate
          AnalyticStore.agentList.push(e.value);
        } else {
          AnalyticStore.agentList.remove(exist);
        }
      } else {
        AnalyticStore.agentList.clear();
      }
    }

    render() {
      const channelHandlerList = AnalyticStore.companyChannelHandlerList;
      const channelHandlerText =
        channelHandlerList.length > 0
          ? prepareDisplayName(channelHandlerList)
          : "All channel";
      const agentList = AnalyticStore.agentList;
      const agentText =
        agentList.length > 0 ? prepareDisplayName(agentList) : "All agent";
      const onChannelHandlerChange = this.onChannelHandlerChange;
      const onAgentChange = this.onAgentChange;

      return (
        <Wrapper spaceBetween>
          <PickerChannel onSelected={onChannelHandlerChange}>
            <Field text={channelHandlerText} />
          </PickerChannel>
          <PickerAgent showAllAgents={true} onSelected={onAgentChange} selectedList={agentList}>
            <Field text={agentText} />
          </PickerAgent>
          <WidgetMember />
          <LocaleProvider locale={enUS}>
            <DatePicker.RangePicker
              value={[
                moment(AnalyticStore.startTime),
                moment(AnalyticStore.endTime)
              ]}
              format="YYYY-MM-DD"
              onChange={this.onChangeDate}
            />
          </LocaleProvider>
        </Wrapper>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/Filter.js